export const filtersHaveBeenUpdated = (prevFilters, nextFilters) => {
  let prevFiltersClone = JSON.parse(JSON.stringify(prevFilters));
  let nextFiltersClone = JSON.parse(JSON.stringify(nextFilters));
  delete prevFiltersClone.page;
  delete nextFiltersClone.page;
  if (JSON.stringify(prevFiltersClone) !== JSON.stringify(nextFiltersClone)) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/filtersHaveBeenUpdated.ts